export enum SuggestionTypes {
  SPECIALTY = 'Specialty',
  PROVIDER = 'Provider',
  QUICKLINK = 'Quick Links',
  COMMON_SEARCHES = 'Common Searches',
  RECENT_SEARCHES = 'Recent Searches',
  LOCATIONS = 'Locations'
}
